<mijn-login-template [title]="getTitle()" [showExtraContentCard]="showExtraContentCard()">
    <div header>
        @if (instantNotification) {
            <ap-notification [status]="instantNotification.status" data-bb="instantNotification" id="instantNotification">
                <div [id]="ariaLabels.IBP_ARIA" [innerHtml]="instantNotification.text"></div>
            </ap-notification>
        }
        @if (genericNotification) {
            <ap-notification [status]="genericNotification.status" data-bb="genericNotification">
                <div [id]="ariaLabels.GENERIC_ARIA" [innerHtml]="genericNotification.text"></div>
            </ap-notification>
        }
        @if (showSessionNotification) {
            <ap-notification status="warning">
                <ap-content [id]="ariaLabels.SHOW_SESSION_ARIA" [key]="'mijn.login.login.wrapper.session.notification.text'"></ap-content>
            </ap-notification>
        }
        @if (digicodeHerstelNotification) {
            <ap-notification [status]="digicodeHerstelNotification.status" data-bb="digicodeHerstelNotification">
                <div [id]="ariaLabels.DIGICODE_HERSTEL_ARIA" [innerHtml]="digicodeHerstelNotification.message"></div>
            </ap-notification>
        }
        <klant-login-accordion [redirect]="showRedirect"></klant-login-accordion>
    </div>
    @if (isCiamEnabled() && loginAvailable()) {
        <div class="ap-display-block ap-margin-bottom-4">
            <p>
                <a href="./auth0inloggen">{{ 'mijn.login.login.wrapper.auth0-login' | apContent }}</a>
            </p>
        </div>
    }
    <div class="ap-display-block ap-margin-bottom-4">
        <strong>
            @if (showRedirect) {
                <div data-bb="signNotificationRedirect">
                    <p>{{ 'mijn.login.login.wrapper.redirect' | apContent }}</p>
                </div>
            }
            @if (!showRedirect) {
                <div data-bb="signNotificationNoRedirect">
                    <p>
                        <ap-content key="{{ 'mijn.login.login.wrapper.no.redirect.' + (tokenType ? tokenType : 'none') }}"></ap-content>
                    </p>
                </div>
            }
        </strong>
    </div>

    <klant-login-sign
        [actionId]="actionId"
        [preferredToken]="preferredToken"
        [additionalTokens]="additionalTokens"
        [ariaLabelsForNotifications]="getAriaLabelsForNotifications()"
        (completed)="complete()"
        (refreshActionId)="setActionId()"
        (updatePassword)="updatePassword($event)"
        (updateUsernamePassword)="updateUsernamePassword($event)"
        (tokenChanged)="onTokenChanged($event)"
        (pendingToken)="onPendingToken($event)"
        (lostBrowserCredentials)="onLostBrowserCredentials($event)"
    >
    </klant-login-sign>

    @if (!tokenType) {
        <div class="ap-display-block">
            <a [href]="'mijn.login.login.wrapper.login.help.url' | apContent">{{
                'mijn.login.login.wrapper.login.help.title' | apContent
            }}</a>
        </div>
    }

    @if (tokenType) {
        <div class="ap-display-block">
            <ap-button (onClick)="sendAnalyticsAndFollowLink()" [text]="true">
                @if (tokenType === 'DIGICODE' && ('mijn.login.login.wrapper.login.problem.password.title' | apContent) !== '') {
                    {{ 'mijn.login.login.wrapper.login.problem.password.title' | apContent }}
                } @else {
                    {{ 'mijn.login.login.wrapper.login.problem.title' | apContent }}
                }
            </ap-button>
        </div>
    }

    <div extra>
        @if (!hasAdditionalTokens() && !tokenType) {
            <div class="registration-message-wrapper" data-bb="registration-message">
                <div class="registration-message-wrapper__icon">
                    <ap-icon [name]="'help'" [size]="'large'"></ap-icon>
                </div>
                <ap-content key="mijn.login.login.wrapper.registration.message"></ap-content>
            </div>
        }

        @if (tokenIsBrowserCode()) {
            <div>
                <a class="ap-display-block ap-margin-bottom-2" [href]="'mijn.login.login.wrapper.extra.add.browsercode.url' | apContent">{{
                    'mijn.login.login.wrapper.extra.add.browsercode.title' | apContent
                }}</a>
                <a [href]="'mijn.login.login.wrapper.extra.remove.browsercode.url' | apContent">{{
                    'mijn.login.login.wrapper.extra.remove.browsercode.title' | apContent
                }}</a>
            </div>
        }
    </div>
</mijn-login-template>
